<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M7.994 16a.447.447 0 0 1-.144-.023l-1.344-.458a10.594 10.594 0 0 1-3-1.592 7.3 7.3 0 0 1-2.148-2.6l-.354-.72a7.109 7.109 0 0 1-.585-1.76A22.683 22.683 0 0 1 0 4.508v-1.02a.765.765 0 0 1 .5-.709L7.843.029a.444.444 0 0 1 .308-.001l7.343 2.75c.3.107.5.39.5.708v.646a25.578 25.578 0 0 1-.394 4.521 7.987 7.987 0 0 1-.695 2.123l-.27.557a7.3 7.3 0 0 1-2.157 2.6c-.908.69-1.92 1.227-3 1.592l-1.342.458a.462.462 0 0 1-.142.017Zm-4.34-9.43a.993.993 0 0 0-.706.293.989.989 0 0 0-.293.7 1 1 0 0 0 .293.709l3.537 3.537a1 1 0 0 0 1.414 0l5.657-5.658a1 1 0 1 0-1.416-1.413l-4.95 4.95-2.829-2.829a1 1 0 0 0-.712-.289h.005Z" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-prodoffering141',
});
</script>
